import { async } from "q";
import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../errorActionHandler";

export const postSendToQueueActionHandler = (data) => async (dispatch) => {
  return await apis.admin.emailTrigger
    .sendToQueue(data)
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.log(error);
    });
};
